<template>
    <v-row class="buttons d-flex justify-start pa-2">
        <DxButton text="Înapoi" icon="arrowleft" styling-mode="contained" type="default" class="back-button"
            @click="goBack" />
    </v-row>
    <div>
        <DxDataGrid ref="dataGrid" :data-source="dsProduse" :show-borders="true" :allow-column-reordering="true"
            :allow-column-resizing="true" :column-resizing-mode="'nextColumn'" :hover-state-enabled="true"
            :filter-sync-enabled="true" height="600" class="grid theme-dependent" key-expr="Id" @exporting="onExporting"
            :column-width="100" :onContextMenuPreparing="onContextMenuPreparing" :show-row-lines="true"
            :onInitNewRow="onInitNewRow" :onEditorPreparing="onEditorPreparing" :onRowInserted="onRowInserted"
            :onRowUpdated="onRowUpdated">

            <DxColumnChooser :enabled='true' title='Selector coloane' :allowSearch="true" sortOrder="asc">
            </DxColumnChooser>
            <DxPaging :page-size="15" :page-index="0" />
            <DxScrolling column-rendering-mode="virtual" />

            <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
            <DxExport :enabled="true" :allow-export-selected-data="true" :formats="['xlsx', 'pdf']" />
            <DxFilterRow :visible="true" />

            <DxEditing :allowUpdating="true" :allowAdding="true" mode="popup">
                <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="1500" :height="780">
                    <DxToolbarItem :template="customTitleTemplate" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after"
                        :options="successButtonOptions" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
                </DxPopup>
                <DxFormGrid :col-count="3">
                    <DxFormItemGrid item-type="group" caption="Date inițiale" :col-count="1">
                        <DxFormItemGrid dataField="Cod" :label="{ text: 'Cod Producător' }"
                            :editor-options="{ valueChangeEvent: 'input', validationMessageMode: 'always' }">
                            <DxRequiredRule message="Câmpul Cod este obligatoriu." />
                        </DxFormItemGrid>
                        <DxFormItemGrid dataField="CodIntern"
                            :editor-options="{ readOnly: true, placeholder: '#AUTO' }" />

                        <DxFormItemGrid dataField="Nume" :label="{ text: 'Denumire' }" editor-type="dxTextArea"
                            :editor-options="{ valueChangeEvent: 'input', validationMessageMode: 'always', height: 142 }">
                            <DxRequiredRule message="Câmpul Denumire este obligatoriu." />
                        </DxFormItemGrid>
                    </DxFormItemGrid>
                    <DxFormItemGrid item-type="group" caption="Prezentare" :col-count="2">
                        <DxFormItemGrid dataField="Producator" />
                        <DxFormItemGrid data-field="ProducatorTaraId" editor-type="dxSelectBox"
                            :editor-options="{ dataSource: dsTari, valueExpr: 'ID', displayExpr: 'Nume', searchEnabled: true, showClearButton: true, placeholder: 'Selectează' }"
                            :label="{ text: 'Producator Țara' }" />
                        <DxFormItemGrid dataField="CodNc8id" :label="{ text: 'Cod NC8' }" />
                        <DxFormItemGrid dataField="CodBare" />
                        <DxFormItemGrid dataField="CodCPV" />
                        <DxSimpleItem data-field="Imagine" :template="imageUploaderTemplate"
                            :label="{ text: 'Imagine' }" />
                        <DxFormItemGrid dataField="Serviciu" editor-type="dxSwitch"> </DxFormItemGrid>
                        <DxFormItemGrid dataField="Stocabil" editor-type="dxSwitch"> </DxFormItemGrid>
                        <DxFormItemGrid dataField="Url" />
                        <DxFormItemGrid dataField="Marker" />
                    </DxFormItemGrid>
                    <DxFormItemGrid item-type="group" caption="Stoc" :col-count="2">
                        <DxFormItemGrid data-field="UnitateId" editor-type="dxSelectBox"
                            :editor-options="{ dataSource: dsUnitati, valueExpr: 'Id', displayExpr: 'Nume', searchEnabled: true, showClearButton: true, placeholder: 'Bucati' }"
                            :label="{ text: 'UM' }" />
                        <DxFormItemGrid dataField="TipEtichetaId" :label="{ text: 'Tip Etichetă' }" />
                        <DxFormItemGrid dataField="SeCantareste" editor-type="dxSwitch" />
                        <DxFormItem dataField="Activ" editor-type="dxSwitch" />
                        <DxFormItemGrid dataField="MasaBuc" editor-type="dxNumberBox"
                            :editor-options="{ format: '#,##0.00######', min: 0, showSpinButtons: true }" />
                        <DxFormItemGrid dataField="MasaBucNet" editor-type="dxNumberBox"
                            :editor-options="{ format: '#,##0.00######', min: 0, showSpinButtons: true }" />
                        <DxFormItemGrid dataField="SursaProdus" :label="{ text: 'Sursă Produs' }" />
                        <DxFormItemGrid dataField="QavertizareStoc" editor-type="dxNumberBox"
                            :editor-options="{ format: '#,##0.###', min: 0, showSpinButtons: true }" />
                        <DxFormItemGrid dataField="Qaprovizionare" editor-type="dxNumberBox"
                            :editor-options="{ format: '#,##0.###', min: 0, showSpinButtons: true }" />
                        <DxFormItemGrid dataField="LocDepozitare" />
                    </DxFormItemGrid>
                    <DxFormItemGrid item-type="group" caption="Clasificare" :col-count="1">
                        <DxFormItemGrid data-field="UnitateAmbalajId" editor-type="dxSelectBox"
                            :editor-options="{ dataSource: dsUnitati, valueExpr: 'Id', displayExpr: 'Nume', searchEnabled: true, showClearButton: true, placeholder: 'Selectează' }"
                            :label="{ text: 'UM Ambalaj' }" />
                        <DxFormItemGrid dataField="CantitatePt1Fa" editor-type="dxNumberBox"
                            :editor-options="{ format: '#,##0.###', min: 0, showSpinButtons: true }" />
                        <DxFormItemGrid data-field="CategorieContabilaId" editor-type="dxSelectBox"
                            :editor-options="{ dataSource: dsCategorieContabila, valueExpr: 'Id', displayExpr: 'Nume', searchEnabled: true, showClearButton: true, placeholder: '371.01 - Marfuri Gestiunea 01  -XXX' }"
                            :label="{ text: 'Categorie Contabilă' }" />
                        <DxFormItem dataField="CategTva" />
                        <DxFormItem dataField="CategTvaMotivScutire" />
                        <DxFormItemGrid data-field="ClasificatieEconomicaId" editor-type="dxSelectBox"
                            :editor-options="{ dataSource: dsClasificatieEconomica, valueExpr: 'ID', displayExpr: 'Cod', searchEnabled: true, showClearButton: true, placeholder: 'Selectează' }"
                            :label="{ text: 'Clasificație Economică' }" />
                        <DxFormItemGrid data-field="CodD394" editor-type="dxSelectBox"
                            :editor-options="{ dataSource: dsCoduriD394, valueExpr: 'Nume', displayExpr: 'Nume', searchEnabled: true, showClearButton: true, placeholder: 'Selectează' }"
                            :label="{ text: 'Cod D394' }" />
                    </DxFormItemGrid>
                    <DxFormItemGrid item-type="group" caption="Comercial" :col-count="2">
                        <DxFormItemGrid dataField="NumeComercial" />
                        <DxFormItemGrid dataField="Descriere" />
                        <DxFormItemGrid dataField="Pret" editor-type="dxNumberBox" :label="{ text: 'Preț' }"
                            :editor-options="{ format: '#,##0.00####', showSpinButtons: true, min: 0, placeholder: '0' }" />
                        <DxFormItemGrid dataField="PretVanzare" editor-type="dxNumberBox"
                            :label="{ text: 'Preț Vânzare' }"
                            :editor-options="{ format: '#,##0.00####', showSpinButtons: true, min: 0, placeholder: '0' }" />
                        <DxFormItem dataField="PretVanzareAnterior" editor-type="dxNumberBox"
                            :label="{ text: 'Preț Vânzare Anterior' }"
                            :editor-options="{ format: '#,##0.00####', showSpinButtons: true, min: 0 }" />
                        <DxFormItem dataField="PretVanzareData" editor-type="dxDateBox"
                            :label="{ text: 'Preț Vânzare Dată' }"
                            :editor-options="{ type: 'date', displayFormat: 'dd.MM.yyyy' }" />
                        <DxFormItemGrid data-field="PretValutaId" editor-type="dxSelectBox"
                            :editor-options="{ dataSource: dsPretValuta, valueExpr: 'Id', displayExpr: 'Simbol', searchEnabled: true, showClearButton: true, placeholder: 'RON' }"
                            :label="{ text: 'Moneda' }" />
                        <DxFormItemGrid data-field="PretCursBancaId" editor-type="dxSelectBox"
                            :editor-options="{ dataSource: dsBanci, valueExpr: 'ID', displayExpr: 'Cod', searchEnabled: true, showClearButton: true, placeholder: 'Selectează' }"
                            :label="{ text: 'Preț Curs Bancă' }" />
                        <DxFormItemGrid dataField="TvaCurent" editor-type="dxNumberBox"
                            :editor-options="{ format: '#,##0.00####', min: 0, showSpinButtons: true }" />
                        <DxFormItemGrid data-field="TvaCurentData" editor-type="dxDateBox"
                            :editor-options="{ value: new Date(), displayFormat: 'dd/MM/yyyy', type: 'date' }" />
                        <DxFormItemGrid dataField="TvaAnterior" editor-type="dxNumberBox"
                            :editor-options="{ format: '#,##0.00####', min: 0, showSpinButtons: true }" />
                        <DxFormItemGrid dataField="TaxaVamala" editor-type="dxNumberBox"
                            :label="{ text: 'Taxă Timbru Verde' }"
                            :editor-options="{ format: '#,##0.00####', showSpinButtons: true, min: 0 }" />
                        <DxFormItemGrid dataField="TaxareInversa" editor-type="dxSwitch"
                            :label="{ text: 'Taxare Inversă' }"
                            :editor-options="{ switchedOnText: 'Da', switchedOffText: 'Nu' }" />
                        <DxFormItemGrid dataField="GarantieLuni" editor-type="dxNumberBox"
                            :editor-options="{ min: 12, showSpinButtons: true }" />
                    </DxFormItemGrid>

                    <DxFormItemGrid item-type="group" caption="Marketplace" :col-count="1">
                        <DxFormItemGrid dataField="CodPnk" />
                        <DxFormItemGrid dataField="CodPNKBG" />
                        <DxFormItemGrid dataField="CodPNKHU" />

                        <DxFormItemGrid data-field="ProdusSgrID" editor-type="dxSelectBox" :editor-options="{
                            dataSource: dsProduse,
                            valueExpr: 'Id',
                            displayExpr: 'Nume',
                            searchEnabled: true,
                            showClearButton: true,
                            placeholder: 'Selectează'
                        }" :label="{ text: 'Produs SGR' }" />

                        <DxFormItem dataField="Compatibilitate" />

                        <DxFormItemGrid item-type="group" :col-count="2">
                            <DxFormItem dataField="WwwID" editor-type="dxNumberBox"
                                :editor-options="{ min: 0, showSpinButtons: true }" />
                            <DxFormItem dataField="WwwSyncedDate" editor-type="dxDateBox"
                                :editor-options="{ type: 'datetime', displayFormat: 'dd.MM.yyyy HH:mm' }" />
                        </DxFormItemGrid>

                        <DxFormItemGrid item-type="group" :col-count="2">
                            <DxFormItem dataField="WwwListat" editor-type="dxSwitch"
                                :editor-options="{ switchedOnText: 'Da', switchedOffText: 'Nu' }" />
                            <DxFormItem dataField="WwwVizibil" editor-type="dxSwitch"
                                :editor-options="{ switchedOnText: 'Da', switchedOffText: 'Nu' }" />
                        </DxFormItemGrid>
                    </DxFormItemGrid>


                </DxFormGrid>
            </DxEditing>
            <DxColumn data-field="Cod" :width="110" :fixed="true" caption="Cod Producător" />
            <DxColumn data-field="CodIntern" :width="120" :fixed="true" />
            <DxColumn data-field="Nume" :width="450" :fixed="true" :allow-search="true" />
            <DxColumn data-field="Categorie.Nume" caption="Categorie" />
            <DxColumn data-field="CategorieId" :visible="false" :lookup="{
                dataSource: dsCategorie,
                valueExpr: 'Id',
                displayExpr: 'Nume'
            }" />
            <DxColumn data-field="Unitate.Nume" caption="UM" />
            <DxColumn data-field="UnitateId" :visible="false" :lookup="{
                dataSource: dsUnitati,
                valueExpr: 'Id',
                displayExpr: 'Nume'
            }" />
            <DxColumn caption="Identificare">
                <DxColumn data-field="NumeComercial" :visible="false" />
                <DxColumn data-field="Descriere" :visible="false" />
                <DxColumn data-field="CodBare" :visible="false" />
                <DxColumn data-field="Marker" :visible="false" />
            </DxColumn>

            <DxColumn caption="Clasificare & Contabil">
                <DxColumn data-field="CategorieContabila.Nume" caption="Categorie Contabilă" :visible="false" />
                <DxColumn data-field="CategorieContabilaId" :visible="false" :lookup="{
                    dataSource: dsCategorieContabila,
                    valueExpr: 'Id',
                    displayExpr: 'Nume'
                }" />
                <DxColumn data-field="ClasificatieEconomica.Cod" :visible="false" caption="Clasificație Economică" />
                <DxColumn data-field="ClasificatieEconomicaId" :visible="false" :lookup="{
                    dataSource: dsClasificatieEconomica,
                    valueExpr: 'ID',
                    displayExpr: 'Cod'
                }" />
                <DxColumn data-field="TipEtichetaId" :visible="false" caption="Tip Etichetă" />
                <DxColumn data-field="CoduriD394.Nume" :visible="false" />
                <DxColumn data-field="CodD394" :visible="false" :lookup="{
                    dataSource: dsCoduriD394,
                    valueExpr: 'Nume',
                    displayExpr: 'Nume'
                }" />
                <DxColumn data-field="CategTva" :visible="false" />
                <DxColumn data-field="CategTvaMotivScutire" :visible="false" />
                <DxColumn data-field="CodCPV" :visible="false" />
                <DxColumn data-field="CodNc8id" :visible="false" />
                <DxColumn data-field="Compatibilitate" :visible="false" />
                <DxColumn data-field="Activ" :visible="false" />
                <DxColumn data-field="SursaProdus" :visible="false" caption="Sursă Produs" />
            </DxColumn>

            <DxColumn caption="Prețuri & Valută">
                <DxColumn data-field="Pret" caption="Preț" :visible="false" />
                <DxColumn data-field="PretVanzare" caption="Preț Vânzare" :visible="false" />
                <DxColumn data-field="PretValuta.Simbol" caption="Preț Valută" :visible="false" />
                <DxColumn data-field="PretValutaId" :visible="false" :lookup="{
                    dataSource: dsPretValuta,
                    valueExpr: 'Id',
                    displayExpr: 'Simbol'
                }" />
                <DxColumn data-field="PretCursBanca.Cod" caption="Preț Curs Bancă" :visible="false" />
                <DxColumn data-field="PretCursBancaId" :visible="false" :lookup="{
                    dataSource: dsBanci,
                    valueExpr: 'ID',
                    displayExpr: 'Cod'
                }" />
                <DxColumn data-field="PretVanzareData" :visible="false" />
                <DxColumn data-field="PretVanzareAnterior" :visible="false" />
                <DxColumn data-field="TaxareInversa" :visible="false" />
                <DxColumn data-field="TaxaVamala" caption="Taxă Vamală" :visible="false" />
            </DxColumn>

            <DxColumn caption="TVA">
                <DxColumn data-field="TvaCurent" :visible="false" />
                <DxColumn data-field="TvaCurentData" editor-type="dxDateBox" :visible="false"
                    :editor-options="{ displayFormat: 'dd/MM/yyyy', type: 'date' }" />
                <DxColumn data-field="TvaAnterior" :visible="false" />
            </DxColumn>

            <DxColumn caption="Greutate & Măsurare">
                <DxColumn data-field="MasaBuc" caption="Masă Bucată" :visible="false" />
                <DxColumn data-field="MasaBucNet" :visible="false" />
                <DxColumn data-field="SeCantareste" caption="Se cântărește" :width="120" :visible="false" />
            </DxColumn>

            <DxColumn caption="Stoc & Depozit">
                <DxColumn data-field="Stocabil" data-type="boolean" :visible="false" />
                <DxColumn data-field="QavertizareStoc" :visible="false" />
                <DxColumn data-field="Qaprovizionare" :visible="false" />
                <DxColumn data-field="LocDepozitare" :visible="false" />
                <DxColumn data-field="UnitateAmbalaj.Nume" caption="UM FA" :visible="false" />
                <DxColumn data-field="UnitateAmbalajId" :visible="false" :lookup="{
                    dataSource: dsUnitati,
                    valueExpr: 'Id',
                    displayExpr: 'Nume'
                }" />
                <DxColumn data-field="CantitatePt1Fa" :visible="false" />
                <DxColumn data-field="Serviciu" data-type="boolean" :set-cell-value="serviciuSetCellValue"
                    :visible="false" />
            </DxColumn>

            <DxColumn caption="Producător & Origine">
                <DxColumn data-field="Producator" :visible="false" />
                <DxColumn data-field="ProducatorTara.Nume" :visible="false" />
                <DxColumn data-field="ProducatorTaraId" :visible="false" :lookup="{
                    dataSource: dsTari,
                    valueExpr: 'ID',
                    displayExpr: 'Nume'
                }" />
                <DxColumn data-field="GarantieLuni" :visible="false" />
            </DxColumn>

            <DxColumn caption="Web & Media">
                <DxColumn data-field="Url" :visible="false" />
                <DxColumn data-field="Imagine" :visible="false" :cell-template="cellTemplateImg" />
                <DxColumn data-field="WwwListat" :visible="false" />
                <DxColumn data-field="WwwVizibil" :visible="false" />
                <DxColumn data-field="WwwID" :visible="false" />
                <DxColumn data-field="WwwSyncedDate" :visible="false" />
            </DxColumn>

            <DxColumn caption="Marketplace-uri">
                <DxColumn data-field="eMAGID" :visible="false" />
                <DxColumn data-field="eMAGIDBG" :visible="false" />
                <DxColumn data-field="eMAGIDHU" :visible="false" />
                <DxColumn data-field="CodPnk" :visible="false" />
                <DxColumn data-field="CodPNKBG" :visible="false" />
                <DxColumn data-field="CodPNKHU" :visible="false" />
                <DxColumn data-field="ProdusSgr.Nume" :visible="false" />
                <DxColumn data-field="ProdusSgrID" :visible="false" :lookup="{
                    dataSource: dsProduse,
                    valueExpr: 'Id',
                    displayExpr: 'Nume'
                }" />

            </DxColumn>

            <DxColumn caption="Audit">
                <DxColumn data-field="UserCreare" :visible="false" />
                <DxColumn data-field="DataCreare" :visible="false" />
                <DxColumn data-field="UserModificare" :visible="false" />
                <DxColumn data-field="DataModificare" :visible="false" />
            </DxColumn>
        </DxDataGrid>
        <DxPopupAdd v-model:visible="isProductsDetailsVisible" :drag-enabled="false" :hide-on-outside-click="true"
            :show-close-button="true" container=".dx-viewport" :width="800" :height="700">
            <DxScrollView width="100%" height="100%">
                <div class="products-details-container">
                    <div>
                        <div class="section-title">Informații produse</div>
                        <div class="products-info-item">
                            <div class="info-label">Cod Producător:</div>
                            <div class="info-value">{{ selectedProducts.Cod || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Cod Intern:</div>
                            <div class="info-value">{{ selectedProducts.CodIntern || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Nume:</div>
                            <div class="info-value">{{ selectedProducts.Nume || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Producator:</div>
                            <div class="info-value">{{ selectedProducts.Producator || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Producator Tara:</div>
                            <div class="info-value">{{ selectedProducts.ProducatorTara || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Cod NC8:</div>
                            <div class="info-value">{{ selectedProducts.CodNc8id || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Cod Bare:</div>
                            <div class="info-value">{{ selectedProducts.CodBare || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Cod CPV:</div>
                            <div class="info-value">{{ selectedProducts.CodCPV || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Imagine:</div>
                            <div class="info-value">{{ selectedProducts.Imagine || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Serviciu:</div>
                            <div class="info-value">{{ selectedProducts.Serviciu || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Stocabil:</div>
                            <div class="info-value">{{ selectedProducts.Stocabil || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">URL:</div>
                            <div class="info-value">{{ selectedProducts.Url || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Marker:</div>
                            <div class="info-value">{{ selectedProducts.Marker || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">UM:</div>
                            <div class="info-value">{{ selectedProducts.Unitate || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Se cântărește:</div>
                            <div class="info-value">{{ selectedProducts.SeCantareste || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Masa Bucata:</div>
                            <div class="info-value">{{ selectedProducts.MasaBuc || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">MasaBucNet:</div>
                            <div class="info-value">{{ selectedProducts.MasaBucNet || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Tip Eticheta:</div>
                            <div class="info-value">{{ selectedProducts.TipEtichetaId || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Sursa Produs:</div>
                            <div class="info-value">{{ selectedProducts.SursaProdus || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Q Avertizare Stoc:</div>
                            <div class="info-value">{{ selectedProducts.QavertizareStoc || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">QAprovizionare:</div>
                            <div class="info-value">{{ selectedProducts.Qaprovizionare || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Loc Depozitare:</div>
                            <div class="info-value">{{ selectedProducts.LocDepozitare || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">UM FA:</div>
                            <div class="info-value">{{ selectedProducts.UnitateAmbalaj || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Cantitate 1 FA:</div>
                            <div class="info-value">{{ selectedProducts.CantitatePt1Fa || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Denumire Comerciala:</div>
                            <div class="info-value">{{ selectedProducts.NumeComercial || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Descriere:</div>
                            <div class="info-value">{{ selectedProducts.Descriere || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Pret Catalog:</div>
                            <div class="info-value">{{ selectedProducts.Pret }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Pret Vanzare:</div>
                            <div class="info-value">{{ selectedProducts.PretVanzare }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Pret Valuta:</div>
                            <div class="info-value">{{ selectedProducts.PretValuta || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Pret Curs Bancar:</div>
                            <div class="info-value">{{ selectedProducts.PretCursBanca || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">%TVA Curent:</div>
                            <div class="info-value">{{ selectedProducts.TvaCurent || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Data TVA Curent:</div>
                            <div class="info-value">{{ selectedProducts.TvaCurentData || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">TvaAnterior:</div>
                            <div class="info-value">{{ selectedProducts.TvaAnterior || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Taxa Vamala:</div>
                            <div class="info-value">{{ selectedProducts.TaxaVamala || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Taxare Inversa:</div>
                            <div class="info-value">{{ selectedProducts.TaxareInversa || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Garantie (luni):</div>
                            <div class="info-value">{{ selectedProducts.GarantieLuni || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Categorie Contabila:</div>
                            <div class="info-value">{{ selectedProducts.CategorieContabila || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Clasificatie Economica:</div>
                            <div class="info-value">{{ selectedProducts.ClasificatieEconomica || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Cod D394:</div>
                            <div class="info-value">{{ selectedProducts.CodD394 || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Produs SGR:</div>
                            <div class="info-value">{{ selectedProducts.ProdusSgrID || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">CodPNK:</div>
                            <div class="info-value">{{ selectedProducts.CodPnk || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">CodPNKBG:</div>
                            <div class="info-value">{{ selectedProducts.CodPNKBG || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">CodPNKHU:</div>
                            <div class="info-value">{{ selectedProducts.CodPNKHU || '-' }}</div>
                        </div>


                        <div class="products-info-item">
                            <div class="info-label">Compatibilitate:</div>
                            <div class="info-value">{{ selectedProducts.Compatibilitate || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Pret Vanzare Data:</div>
                            <div class="info-value">{{ selectedProducts.PretVanzareData || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Pret Vanzare Anterior:</div>
                            <div class="info-value">{{ selectedProducts.PretVanzareAnterior || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Categorie TVA:</div>
                            <div class="info-value">{{ selectedProducts.CategTva || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Categorie TVA Motiv Scutire:</div>
                            <div class="info-value">{{ selectedProducts.CategTvaMotivScutire || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">Activ:</div>
                            <div class="info-value">{{ selectedProducts.Activ || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">WwwListat:</div>
                            <div class="info-value">{{ selectedProducts.WwwListat || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">WwwVizibil:</div>
                            <div class="info-value">{{ selectedProducts.WwwVizibil || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">WwwID:</div>
                            <div class="info-value">{{ selectedProducts.WwwID || '-' }}</div>
                        </div>
                        <div class="products-info-item">
                            <div class="info-label">WwwSyncedDate:</div>
                            <div class="info-value">{{ selectedProducts.WwwSyncedDate || '-' }}</div>
                        </div>

                        <div class="products-info-item">
                            <div class="info-label">Categorie:</div>
                            <div class="info-value">{{ selectedProducts.Categorie || '-' }}</div>
                        </div>

                    </div>
                </div>
            </DxScrollView>
        </DxPopupAdd>

    </div>
</template>
<script lang="ts">
import DxDropDownButton from 'devextreme-vue/drop-down-button';
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd from 'devextreme-vue/popup';
import { DxSimpleItem, DxLabel } from 'devextreme-vue/form';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DxForm, DxItem as DxFormItem } from 'devextreme-vue/form';
import DxDropDownBox from "devextreme-vue/drop-down-box";
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { jsPDF } from 'jspdf';
import { exportDataGrid as exportDataGridPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportDataGridExcel } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import {
    DxItem as DxGridToolbarItem,
    DxLookup,
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar as DxGridToolbar,
    DxEditing,
    DxColumnChooser,
    DxGrouping,
    DxGroupPanel,
    DxTexts,
    DxExport,
    DxSearchPanel,
    DxMasterDetail,
    DxPopup,
    DxToolbarItem,
    DxForm as DxFormGrid,
    DxItem as DxFormItemGrid,
    DxScrolling,
    DxHeaderFilter,
    DxColumnFixing,
    DxPager,
    DxValidationRule,
    DxRequiredRule,
} from 'devextreme-vue/data-grid';


export default defineComponent({
    components: {
        DxGridToolbar,
        DxDataGrid,
        DxColumn,
        DxSorting,
        DxSelection,
        DxFilterRow,
        DxStateStoring,
        DxLoadPanel,
        DxPaging,
        DxButton,
        DxEditing,
        DxPopupAdd,
        DxForm,
        DxSimpleItem,
        DxLabel,
        DxScrollView,
        DxLookup,
        DxColumnChooser,
        DxGrouping,
        DxGroupPanel,
        DxTexts,
        DxExport,
        DxSearchPanel,
        DxMasterDetail,
        DxPopup,
        DxToolbarItem,
        DxFormGrid,
        DxGridToolbarItem,
        DxScrolling,
        DxHeaderFilter,
        DxDropDownButton,
        DxFormItem,
        DxDropDownBox,
        DxFormItemGrid,
        DxColumnFixing,
        DxPager,
        DxValidationRule,
        DxRequiredRule,
    },
    data() {

        return {
            dsClase: {} as DataSource,
            dsProduse: {} as DataSource,
            dsUnitati: {} as DataSource,
            dsCategorie: {} as DataSource,
            dsCategorieContabila: {} as DataSource,
            dsPretValuta: {} as DataSource,
            dsTari: {} as DataSource,
            dsBanci: {} as DataSource,
            dsCoduriD394: {} as DataSource,
            dsClasificatieEconomica: {} as DataSource,
            isModalVisible: false,
            isProductsDetailsVisible: false,
            dataGrid: ref<DxDataGrid | null>(null),
            formInstance: null as any,
            lastSaveError: null,
            selectedProducts: {
                Cod: '',
                Nume: '',
                Unitate: '',
                ProducatorTara: '',
                UnitateAmbalaj: '',
                Categorie: '',
                CategorieContabila: '',
                CodIntern: '',
                TaxaVamala: '',
                Url: '',
                PretVanzare: '',
                UserCreare: '',
                Pret: '',
                DataCreare: '',
                UserModificare: '',
                DataModificare: '',
                MasaBuc: '',
                SeCantareste: '',
                PretValuta: '',
                PretCursBanca: '',
                PretCursBancaId: '',
                SursaProdus: '',
                TipEtichetaId: '',
                LocDepozitare: '',
                ClasificatieEconomica: '',
                Imagine: '',
                QavertizareStoc: '',
                Qaprovizionare: '',
                UnitateAmbalajID: '',
                CantitatePt1Fa: '',
                TvaCurent: '',
                TvaCurentData: null,
                TvaAnterior: '',
                Stocabil: '',
                Serviciu: '',
                TaxareInversa: '',
                Marker: '',
                CodD394: '',
                GarantieLuni: '',
                Producator: '',
                CodBare: '',
                NumeComercial: '',
                ProducatorTaraID: '',
                CodNc8id: '',
                Descriere: '',
                Compatibilitate: '',
                PretVanzareData: '',
                PretVanzareAnterior: '',
                CategTva: '',
                CategTvaMotivScutire: '',
                MasaBucNet: '',
                CodPnk: '',
                eMAGID: '',
                CodPNKBG: '',
                CodPNKHU: '',
                eMAGIDBG: '',
                eMAGIDHU: '',
                ProdusSgrID: '',
                CodCPV: '',
                Activ: '',
                WwwListat: '',
                WwwVizibil: '',
                WwwID: '',
                WwwSyncedDate: '',
            },
            formData: {
                CategorieId: null,
                ClasaId: null,
                Serviciu: false,
                Stocabil: true,
                UnitateId: '31FD11E4-19B7-46E0-BBD5-204595349595',
                Pret: '',
                PretVanzare: '',
                Imagine: null

            },
            successButtonOptions: {
                type: 'success',
                stylingMode: 'contained',
                text: 'Salvează',
                onClick: () => {
                    this.SaveEdit();
                },
            },
            dangerButtonOptions: {
                type: 'danger',
                stylingMode: 'contained',
                text: 'Închide',
                onClick: () => {
                    this.onCancel();
                },
            },
            customTitleTemplate() {
                return `
            <div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:1550px; color: white; 
            font-weight: bold;  padding: 10px; padding-right: 605px;  position: relative;  left: 30px;">
              
            </div>
          `;
            },
        };
    },
    watch: {
        '$route.query.CategorieId': {
            handler() { this.createODataContext() },
            immediate: false
        }

    },
    created() {
        this.createODataContext()
    },
    methods: {
        createODataContext() {
            const catId = this.$route.query.CategorieId || null

            this.dsProduse = new DataSource({
                store: new ODataStore({
                    url: AppSetting.API_Url_ComercialOdata + 'PRO_Produse',
                    key: 'Id',
                    version: 4,
                    errorHandler: (e) => {
                        const msg = e?.errorDetails || 'Codul sau denumirea produsului există deja!';
                        notify({ message: msg, type: 'error', displayTime: 4000 });
                    },
                    fieldTypes: {
                        Id: 'Guid',
                        CategorieId: 'Guid',
                        UnitateId: 'Guid',
                        UnitateAmbalajId: 'Guid',
                        CategorieContabilaId: 'Guid',
                        ClasificatieEconomicaId: 'Guid',
                        PretValutaId: 'Guid',
                        PretCursBancaId: 'Guid',
                        ProdusSgrID: 'Guid',
                        // /CodD394: 'string'
                    },
                    beforeSend: e => {
                        e.headers = {
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt')
                        };
                        e.params.$expand =
                            "Unitate($select=Nume)," +
                            "Categorie($select=Nume)," +
                            "CategorieContabila($select=Nume)," +
                            "PretValuta($select=Simbol)," +
                            "UnitateAmbalaj($select=Nume)," +
                            "ClasificatieEconomica($select=Cod)," +
                            "CoduriD394($select=Nume)," +
                            "ProducatorTara($select=Nume)," +
                            "ProdusSgr($select=Nume)";



                    }
                }),
                ...(catId ? { filter: ['CategorieId', '=', catId] } : {})
            });

            this.dsCategorie = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'PRO_Categorii',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,
                    fieldTypes: { ClasaId: 'Guid' },
                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'Id',
                    'Nume',
                    'ClasaId'
                ],
                sort: [{ selector: 'Nume', desc: false }]

            });

            this.dsClase = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'PRO_Clase',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'NumeArborescent',
                ],
                sort: [{ selector: 'Nume', desc: false }]

            });
            this.dsCoduriD394 = new DataSource({
                store: {
                    type: 'odata',
                    key: undefined, // fără ID, doar citire
                    url: AppSetting.API_Url_ComercialOdata + 'PRO_CoduriD394',
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    }
                },
                select: ['Nume'],
                sort: [{ selector: 'Nume', desc: false }]
            });

            this.dsClasificatieEconomica = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'BUG_ClasificatieEconomica',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Cod',
                ],
                sort: [{ selector: 'Cod', desc: false }]

            });
            this.dsBanci = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Banci',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Cod',
                ],
                sort: [{ selector: 'Cod', desc: false }]

            });

            this.dsUnitati = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'PRO_Unitati',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'Id',
                    'Nume',
                ],
                sort: [{ selector: 'Nume', desc: false }]

            });
            this.dsCategorieContabila = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CON_CategoriiContabile',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'Id',
                    'Nume',
                ],
                sort: [{ selector: 'Nume', desc: false }]

            });
            this.dsPretValuta = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'Id',
                    'Simbol',
                ],
                sort: [{ selector: 'Simbol', desc: false }]

            });
            this.dsTari = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Tari',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Nume',
                ],
                sort: [{ selector: 'Nume', desc: false }]

            });
        },

        cellTemplateImg(container, options) {
            const val = options.data && options.data.Imagine;
            const src = val ? `data:image/jpeg;base64,${val}` : null;
            const el = document.createElement('div');
            el.style.textAlign = 'center';
            el.innerHTML = src
                ? `<img src="${src}" style="max-width:100px; max-height:70px; border-radius:8px;" />`
                : `<span style="opacity:.5;">—</span>`;
            container.appendChild(el);
        },

        imageUploaderTemplate(data, itemElement) {
            // data.component = instanța dxForm
            const form = data.component;
            // ne asigurăm că formData există
            const fd = form.option('formData') || {};
            if (form.option('formData') == null) {
                form.option('formData', fd);
            }

            const wrap = document.createElement('div');
            wrap.innerHTML = `<input type="file" accept="image/*" />`;
            itemElement.appendChild(wrap);

            const input = wrap.querySelector('input');

            input.onchange = (e) => {
                const target = e.target;
                if (!(target instanceof HTMLInputElement)) return;

                const file = target.files?.[0];
                if (!file) return;

                if (!file.type.startsWith('image/')) {
                    //DevExpress.ui.notify('Selectează o imagine.', 'error', 2000);
                    return;
                }
                if (file.size > 5 * 1024 * 1024) {
                    // DevExpress.ui.notify('Fișier prea mare (max 5 MB).', 'error', 2000);
                    return;
                }

                const reader = new FileReader();
                reader.onload = (ev) => {
                    const dataUrl = String(ev.target?.result || '');
                    const base64 = dataUrl.split(',')[1] || '';

                    // CHEIA: nu facem fd.Imagine = ..., ci folosim API-ul formului:
                    form.updateData('Imagine', base64);

                    //DevExpress.ui.notify('Imagine pregătită pentru salvare.', 'success', 1200);
                };
                reader.readAsDataURL(file);
            };
        },

        onContextMenuPreparing(e) {
            if (e.target === 'content' && e.row && e.row.rowType === 'data') {
                e.items = e.items || []
                e.items.unshift(
                    {
                        text: 'Detaliile produsului',
                        icon: 'search',
                        onItemClick: () => {
                            const rowData = e?.row?.data;
                            if (rowData) {
                                this.showProductsDetails(rowData);
                            }
                        }
                    },

                )
            }
        },
        showProductsDetails(products: any) {

            this.selectedProducts = {
                ...products,

            };
            this.isProductsDetailsVisible = true;
        },

        onInitNewRow(e) {

            const catId = this.$route.query.CategorieId || null;
            if (catId) {
                e.data.CategorieId = catId;
            }
            e.data.Serviciu = false
            e.data.Stocabil = true
            e.data.UnitateId = '31FD11E4-19B7-46E0-BBD5-204595349595'
            e.data.Pret = 0
            e.data.PretVanzare = 0
            e.data.PretValutaId = '0A61647E-7391-4087-BC01-8EB9C2CEDEDD'
            e.data.GarantieLuni = 12
            e.data.Activ = true
            e.data.TvaCurentData = new Date()
            e.data.CategorieContabilaId = '119E7784-3247-409C-AA8B-BB5D5D4A6AE5'
            

        },
        goBack() {
            this.$router.back()
            this.$emit('back')
        }
        ,
        serviciuSetCellValue(newData, value /*, currentRowData */) {
            newData.Serviciu = value
            newData.Stocabil = value ? false : true
        },
        onEditorPreparing(e) {
            if (e.parentType !== 'dataRow' || !e.row?.isNewRow) return;

            if (e.dataField === 'NumeComercial') {
                // actualizează în timp ce tastezi, nu doar la blur
                //e.editorOptions.valueChangeEvent = 'input';

                const grid = e.component;
                const rowIndex = e.row.rowIndex;

                const originalHandler = e.editorOptions.onValueChanged;
                e.editorOptions.onValueChanged = args => {
                    if (originalHandler) originalHandler(args);
                    // copiază în Descriere
                    grid.cellValue(rowIndex, 'Descriere', args.value);
                };
            }
        },
        resetLastError() { this.lastSaveError = null; },
        onRowInserted() {
            this.resetLastError();
            notify('Înregistrarea a fost adăugată.', 'success', 1500);
        },
        onRowUpdated() {
            this.resetLastError();
            notify('Modificările au fost salvate.', 'success', 1500);
        },

        SaveEdit() {
            this.$refs.dataGrid?.instance?.saveEditData();

        },

        onCancel() {
            this.isModalVisible = false;
            this.$refs.dataGrid?.instance?.cancelEditData();
        },

        onExporting(e: any) {
            if (e.format === 'pdf') {
                const doc = new jsPDF();
                exportDataGridPdf({
                    jsPDFDocument: doc,
                    component: e.component,
                    indent: 5,
                }).then(() => {
                    doc.save('Produse.pdf');
                });
            } else if (e.format === 'xlsx') {

                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('preturi');

                exportDataGridExcel({
                    component: e.component,
                    worksheet,
                    autoFilterEnabled: true,
                }).then(() => {
                    workbook.xlsx.writeBuffer().then((buffer: any) => {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Produse.xlsx');
                    });
                });
                e.cancel = true;
            }

        },


    },
    mounted() {
        this.createODataContext();
        this.dataGrid = this.$refs.dataGrid as DxDataGrid;
    },
});
</script>
<style scoped lang="scss">
.products-details-container {
    padding: 20px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.section-title {
    font-size: 18px;
    font-weight: 600;
    color: #444;
    margin: 15px 0 10px 0;
    padding-bottom: 5px;
    border-bottom: 1px solid #eee;
}

.products-info-item {
    display: flex;
    margin: 8px 0;
}

.info-label {
    font-weight: 600;
    color: #555;
    width: 100px;
}

.info-value {
    color: #333;
    flex: 1;
}
.back-button {
    background-color: #f5f5f5 !important;
    color: #1f1e1e !important;
    border: 1px solid #ccc !important;
    border-radius: 4px !important;
    padding: 10px 18px !important;
    margin: 10px !important;
    /* spațiu exterior */
    transition: all 0.2s ease-in-out;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.back-button:hover {
    background-color: #f34f26 !important;
    transform: translateX(-3px);
}

/* forțăm afișarea săgeții mereu */
.back-button .dx-icon {
    display: inline-block !important;
    font-size: 30px;
    opacity: 1 !important;
    visibility: visible !important;
    margin-right: 2px;
    color: #1f1e1e !important;
}
.back-button .dx-button-content .dx-icon {
    font-size: 12px !important;
    color: #1f1e1e !important;
    display: inline-block !important;
    opacity: 1 !important;
    margin-right: 6px;
}

</style>